function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $09a6ea7e11584174$exports = {};
$09a6ea7e11584174$exports = LZString;


class $67a3d5749d1c0a9d$export$c2505dec65d17c74 {
    static #_ = (()=>{
        this.closePopup = "closePopup";
    })();
    static #_1 = (()=>{
        this.layerDeselected = "layerDeselected";
    })();
    static #_2 = (()=>{
        this.drawCreated = "drawCreated";
    })();
    static #_3 = (()=>{
        this.fileLoaded = "fileLoaded";
    })();
    static #_4 = (()=>{
        this.hideSettings = "hideSettings";
    })();
    static #_5 = (()=>{
        this.layerSelected = "layerSelected";
    })();
    static #_6 = (()=>{
        this.layerUpdated = "layerUpdated";
    })();
    static #_7 = (()=>{
        this.loadMapFromFile = "loadMapFromFile";
    })();
    static #_8 = (()=>{
        this.mapClicked = "mapClicked";
    })();
    static #_9 = (()=>{
        this.showPopup = "showPopup";
    })();
    static #_10 = (()=>{
        this.saveMapToFile = "saveMapToFile";
    })();
    static #_11 = (()=>{
        this.saveMapToGeoJSONFile = "saveMapToGeoJSONFile";
    })();
    static #_12 = (()=>{
        this.saveSettings = "saveSettings";
    })();
    static #_13 = (()=>{
        this.showHelp = "showHelp";
    })();
    static #_14 = (()=>{
        this.hideHelp = "hideHelp";
    })();
    static #_15 = (()=>{
        this.showSettings = "showSettings";
    })();
    static #_16 = (()=>{
        this.showSharingPopup = "showSharingPopup";
    })();
    static #_17 = (()=>{
        this.mapZoomChanged = "mapZoomChanged";
    })();
    static #_18 = (()=>{
        this.hideLayer = "hideLayer";
    })();
    static #_19 = (()=>{
        this.showLayer = "showLayer";
    })();
    static #_20 = (()=>{
        this.hideModalWindows = "hideOtherModalWindows";
    })();
    static #_21 = (()=>{
        this.showMapManager = "showMapManager";
    })();
    static #_22 = (()=>{
        this.createNewMap = "createNewMap";
    })();
}


class $b15097c11fd8381b$export$a5245c9b2355d1f8 {
    constructor(){
        this.saveMapToFile = (settings, layersData)=>{
            const mapData = this.mapToJSON(settings, layersData);
            const mapString = JSON.stringify(mapData);
            const blob = new Blob([
                mapString
            ], {
                type: "text/plain;charset=utf-8"
            });
            const hyperlink = document.createElement("a");
            hyperlink.href = URL.createObjectURL(blob);
            hyperlink.download = `${settings.title}.json`;
            hyperlink.click();
        };
        this.saveMapToGeoJSONFile = (settings, layersData)=>{
            let layers = new Array;
            layersData.forEach((layer, layerName)=>{
                layers.push(layer.toGeoJSON());
            });
            const geoJSON = layers[0];
            layers.slice(1).forEach((layer)=>{
                const features = layer.features;
                geoJSON.features.push(...features);
            });
            const mapString = JSON.stringify(geoJSON);
            const blob = new Blob([
                mapString
            ], {
                type: "text/plain;charset=utf-8"
            });
            const hyperlink = document.createElement("a");
            hyperlink.href = URL.createObjectURL(blob);
            hyperlink.download = `${settings.title}.json`;
            hyperlink.click();
        };
        this.saveMapToHash = (settings, layersData)=>{
            const mapData = this.mapToJSON(settings, layersData);
            const mapString = JSON.stringify(mapData);
            const uriEncodedString = (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).compressToEncodedURIComponent(mapString);
            return uriEncodedString;
        };
        this.saveMap = (settings, layersData)=>{
            const mapData = this.mapToJSON(settings, layersData);
            const mapString = JSON.stringify(mapData);
            localStorage.setItem(`Map_${settings.title}`, (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).compress(mapString));
            this.saveMapList(settings.title);
            this.saveLastMapSelected(settings.title);
        };
        this.saveMapList = (mapTitle)=>{
            let mapList = this.loadMapListFromStorage();
            if (mapList.includes(mapTitle)) mapList = mapList.filter((title)=>title !== mapTitle);
            mapList.splice(0, 0, mapTitle);
            localStorage.setItem("MapList", (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).compress(JSON.stringify(mapList)));
        };
        this.mapToJSON = (settings, layersData)=>{
            let layers = {};
            layersData.forEach((layer, layerName)=>{
                layers[layerName] = layer.toGeoJSON();
            });
            const mapData = {
                "settings": settings,
                "layers": layers,
                "lastSaved": new Date().toISOString()
            };
            return mapData;
        };
        this.saveLastMapSelected = (mapName)=>{
            localStorage.setItem("LastMapSelected", (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).compress(mapName));
        };
        this.copyMap = (settings, layersData)=>{
            let newIndex = 1;
            const mapList = this.loadMapListFromStorage();
            while(mapList.includes(`Map_${settings.title}_copy_${newIndex}`))newIndex++;
            settings.title = `${settings.title}_copy_${newIndex}`;
            this.saveMap(settings, layersData);
        };
        this.loadMapFromHash = (hash)=>{
            let mapString = null;
            if (hash.startsWith("%")) {
                mapString = decodeURIComponent(hash);
                return JSON.parse(mapString);
            } else {
                mapString = (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).decompressFromEncodedURIComponent(hash);
                if (mapString === null) return null;
                return JSON.parse(mapString);
            }
        };
        this.loadMapFromFile = ()=>{
            const fileInput = document.createElement("input");
            fileInput.type = "file";
            fileInput.style.display = "none";
            fileInput.accept = ".json";
            fileInput.onchange = this.readFile;
            document.body.appendChild(fileInput);
            fileInput.click();
        };
        this.loadMapFromRemoteFile = async (url)=>{
            var response = await fetch(url);
            return response.json();
        };
        this.readFile = (e)=>{
            let fileInput = e.target;
            const file = fileInput.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (e)=>{
                if (e.target === null) return;
                const contents = e.target.result || "";
                const map = JSON.parse(contents);
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).fileLoaded, map);
                document.body.removeChild(fileInput);
            };
            reader.readAsText(file, "text/plain;charset=utf-8");
        };
        this.loadLastMapSelected = ()=>{
            const mapData = localStorage.getItem("LastMapSelected");
            if (mapData !== null && mapData !== "undefined") {
                const mapName = (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).decompress(mapData) || "";
                return mapName;
            }
            return "";
        };
        this.loadMapListFromStorage = ()=>{
            const mapListData = localStorage.getItem("MapList");
            if (mapListData !== null && mapListData !== "undefined") {
                const mapList = (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).decompress(mapListData) || "";
                return JSON.parse(mapList);
            }
            return [];
        };
        this.loadMapFromStorage = (mapName)=>{
            const mapData = localStorage.getItem(`Map_${mapName}`);
            if (mapData !== null && mapData !== "undefined") {
                const map = (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).decompress(mapData) || "";
                return JSON.parse(map);
            }
            return null;
        };
        this.deleteMapFromStorage = (mapName)=>{
            localStorage.removeItem(`Map_${mapName}`);
            const mapData = localStorage.getItem("MapList");
            if (mapData !== null && mapData !== "undefined") {
                const data = (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).decompress(mapData) || "";
                const mapList = JSON.parse(data);
                const index = mapList.indexOf(mapName);
                if (index !== -1) {
                    mapList.splice(index, 1);
                    localStorage.setItem("MapList", (0, (/*@__PURE__*/$parcel$interopDefault($09a6ea7e11584174$exports))).compress(JSON.stringify(mapList)));
                }
            }
            return [];
        };
    }
}


var $8e45d868956a51d9$exports = {};
$8e45d868956a51d9$exports = leaflet;


var $e1221edafe081d67$exports = {};
$e1221edafe081d67$exports = PubSub;




class $aa9b293caf6adcb6$export$e5c1a33878e86e9e {
}



class $98a6ce407b2c5f59$export$99f9902640797710 {
    static #_ = (()=>{
        this.Id = "ModalFilters";
    })();
    constructor(){
        this.id = $98a6ce407b2c5f59$export$99f9902640797710.Id;
        this.title = "Modal Filters";
        this.groupName = "filters";
        this.selected = false;
        this.visible = false;
        this._prefix = "modal-filter";
        this._modalFilterIcon = `<svg class="modal-filter-button" data-id="${$98a6ce407b2c5f59$export$99f9902640797710.Id}" width="60" height="60">
            <circle cx="29" cy="29" r="15" stroke="green" stroke-width="3" fill="green" fill-opacity=".2" />
        </svg>`;
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add modal filters to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            button.isFirst = true;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle Car-free streets from the map");
            const icon = document.createElement("i");
            icon.innerHTML = `<svg width="30" height="30"><circle cx="10" cy="10" r="7" stroke="green" stroke-width="3" fill="green" fill-opacity=".2" /></svg>`;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            geoJson["features"].forEach((modelFilter)=>{
                const coordinates = modelFilter.geometry.coordinates;
                const latLng = new $8e45d868956a51d9$exports.LatLng(coordinates[1], coordinates[0]);
                this.addMarker(latLng);
            });
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            "";
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $98a6ce407b2c5f59$export$99f9902640797710.Id) this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapClicked, (msg, e)=>{
                if (this.selected) {
                    $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
                    const latLng = e.latlng;
                    this.addMarker(latLng);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $98a6ce407b2c5f59$export$99f9902640797710.Id);
                }
            });
        };
        this.addMarker = (latLng)=>{
            const modalFilter = new $8e45d868956a51d9$exports.CircleMarker(latLng, {
                draggable: true,
                color: "green",
                radius: 10,
                pane: "filters"
            }).on("click", (e)=>{
                this.deleteMarker(e);
            });
            this._layer.addLayer(modalFilter);
        };
        this.deleteMarker = (e)=>{
            $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
            const marker = e.target;
            this._layer.removeLayer(marker);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $98a6ce407b2c5f59$export$99f9902640797710.Id);
        };
        this.onButtonClick = (event, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $98a6ce407b2c5f59$export$99f9902640797710.Id);
                return;
            }
            this.selectLayer();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $98a6ce407b2c5f59$export$99f9902640797710.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("modal-filter");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("modal-filter");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}






class $26c1c7c717c827e4$export$f023456fc9389cc6 {
    static #_ = (()=>{
        this.Id = "MobilityLanes";
    })();
    constructor(){
        this.id = $26c1c7c717c827e4$export$f023456fc9389cc6.Id;
        this.title = "Mobility Lanes";
        this.groupName = "";
        this.selected = false;
        this.visible = false;
        this._prefix = "mobility-lane";
        this._layerColour = "#2222ff";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add mobility lanes to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle Car-free streets from the map");
            const icon = document.createElement("i");
            icon.style.backgroundColor = this._layerColour;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            if (geoJson) {
                const mobilityLanes = geoJson["features"];
                mobilityLanes.forEach((mobilityLane)=>{
                    const points = new Array();
                    // For a brief period, saving nested the coordinates inside another array.
                    const coordinates = mobilityLane.geometry.coordinates.length === 1 ? mobilityLane.geometry.coordinates[0] : mobilityLane.geometry.coordinates;
                    coordinates.forEach((coordinate)=>{
                        const point = new $8e45d868956a51d9$exports.LatLng(coordinate[1], coordinate[0]);
                        points.push(point);
                    });
                    this.addMarker(points);
                });
            }
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $26c1c7c717c827e4$export$f023456fc9389cc6.Id) this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, (msg, data)=>{
                if (this.selected) {
                    this.addMarker(data.latLngs);
                    this.initialiseNewLine(data.map);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $26c1c7c717c827e4$export$f023456fc9389cc6.Id);
                }
            });
        };
        this.addMarker = (points)=>{
            const polyline = new $8e45d868956a51d9$exports.Polyline(points, {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            }).on("edit", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $26c1c7c717c827e4$export$f023456fc9389cc6.Id);
            });
            const popup = $8e45d868956a51d9$exports.popup({
                minWidth: 30,
                keepInView: false,
                offset: new $8e45d868956a51d9$exports.Point(75, 75)
            });
            const controlList = document.createElement("ul");
            controlList.classList.add("popup-buttons");
            const deleteControl = document.createElement("li");
            deleteControl.classList.add("delete-button");
            deleteControl.addEventListener("click", (e)=>{
                this.deleteMarker(polyline);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, popup);
            });
            controlList.appendChild(deleteControl);
            popup.setContent(controlList);
            polyline.on("click", (e)=>{
                this.markerOnClick(e);
                popup.setLatLng(e.latlng);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, popup);
            });
            this._layer.addLayer(polyline);
        };
        this.deleteMarker = (layer)=>{
            this._layer.removeLayer(layer);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $26c1c7c717c827e4$export$f023456fc9389cc6.Id);
        };
        this.markerOnClick = (e)=>{
            this.selectLayer();
            const polyline = e.target;
            polyline.editing.enable();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $26c1c7c717c827e4$export$f023456fc9389cc6.Id);
        };
        this.onButtonClick = (event, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $26c1c7c717c827e4$export$f023456fc9389cc6.Id);
                return;
            }
            this.initialiseNewLine(map);
            this.selectLayer();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $26c1c7c717c827e4$export$f023456fc9389cc6.Id);
        };
        this.initialiseNewLine = (map)=>{
            const options = {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            };
            this._newLine = new $8e45d868956a51d9$exports.Draw.Polyline(map, options);
            this._newLine.enable();
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this._layer.eachLayer((layer)=>{
                layer.editing.disable();
            });
            if (this._newLine) this._newLine.disable();
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("mobility-lane");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("mobility-lane");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}






class $45a16fc831ffc1cd$export$59b7e6c00f56503 {
    static #_ = (()=>{
        this.Id = "TramLines";
    })();
    constructor(){
        this.id = $45a16fc831ffc1cd$export$59b7e6c00f56503.Id;
        this.title = "Tram Lines";
        this.selected = false;
        this.visible = false;
        this._prefix = "tram-line";
        this._layerColour = "#ff5e00";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add tram lines to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle Car-free streets from the map");
            const icon = document.createElement("i");
            icon.style.backgroundColor = this._layerColour;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            const br = document.createElement("br");
            holdingElement.appendChild(br);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            if (geoJson) {
                const tramLines = geoJson["features"];
                tramLines.forEach((tramLine)=>{
                    const points = new Array();
                    // For a brief period, saving nested the coordinates inside another array, for some reason.
                    const coordinates = tramLine.geometry.coordinates.length === 1 ? tramLine.geometry.coordinates[0] : tramLine.geometry.coordinates;
                    coordinates.forEach((coordinate)=>{
                        const point = new $8e45d868956a51d9$exports.LatLng(coordinate[1], coordinate[0]);
                        points.push(point);
                    });
                    this.addMarker(points);
                });
            }
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $45a16fc831ffc1cd$export$59b7e6c00f56503.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                if (this.selected) this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, (msg, data)=>{
                if (this.selected) {
                    this.addMarker(data.latLngs);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $45a16fc831ffc1cd$export$59b7e6c00f56503.Id);
                }
            });
        };
        this.addMarker = (points)=>{
            const polyline = new $8e45d868956a51d9$exports.Polyline(points, {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            }).on("edit", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $45a16fc831ffc1cd$export$59b7e6c00f56503.Id);
            });
            const popup = $8e45d868956a51d9$exports.popup({
                minWidth: 30,
                keepInView: true
            });
            const controlList = document.createElement("ul");
            controlList.classList.add("popup-buttons");
            const deleteControl = document.createElement("li");
            deleteControl.classList.add("delete-button");
            deleteControl.addEventListener("click", (e)=>{
                this.deleteMarker(polyline);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, popup);
            });
            controlList.appendChild(deleteControl);
            popup.setContent(controlList);
            polyline.on("click", (e)=>{
                this.markerOnClick(e);
                popup.setLatLng(e.latlng);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, popup);
            });
            this._layer.addLayer(polyline);
        };
        this.deleteMarker = (layer)=>{
            this._layer.removeLayer(layer);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $45a16fc831ffc1cd$export$59b7e6c00f56503.Id);
        };
        this.markerOnClick = (e)=>{
            this.selectLayer();
            const polyline = e.target;
            polyline.editing.enable();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $45a16fc831ffc1cd$export$59b7e6c00f56503.Id);
        };
        this.onButtonClick = (event, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $45a16fc831ffc1cd$export$59b7e6c00f56503.Id);
                return;
            }
            this.selected = true;
            const options = {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            };
            const polyline = new $8e45d868956a51d9$exports.Draw.Polyline(map, options);
            polyline.enable();
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $45a16fc831ffc1cd$export$59b7e6c00f56503.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this._layer.eachLayer((layer)=>{
                layer.editing.disable();
            });
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("tram-line");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("tram-line");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = $8e45d868956a51d9$exports.geoJSON();
        this.id;
        this.title;
        this.selected = false;
        this.setupSubscribers();
    }
}






class $730e4c66c7c616fe$export$45fdd0118d421bcb {
    static #_ = (()=>{
        this.Id = "CarFreeStreets";
    })();
    constructor(){
        this.id = $730e4c66c7c616fe$export$45fdd0118d421bcb.Id;
        this.title = "Car-free Streets";
        this.groupName = "";
        this.selected = false;
        this.visible = false;
        this._prefix = "car-free-street";
        this._layerColour = "#00bb00";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add car-free streets to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle Car-free streets from the map");
            const icon = document.createElement("i");
            icon.style.backgroundColor = this._layerColour;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            if (geoJson) {
                const carFreeStreets = geoJson["features"];
                carFreeStreets.forEach((carFreeStreet)=>{
                    const points = new Array();
                    // For a brief period, the coordinates were incorrectly nested inside another array.
                    const coordinates = carFreeStreet.geometry.coordinates.length === 1 ? carFreeStreet.geometry.coordinates[0] : carFreeStreet.geometry.coordinates;
                    coordinates.forEach((coordinate)=>{
                        const point = new $8e45d868956a51d9$exports.LatLng(coordinate[1], coordinate[0]);
                        points.push(point);
                    });
                    this.addMarker(points);
                });
            }
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $730e4c66c7c616fe$export$45fdd0118d421bcb.Id) {
                    if (this.selected) this.deselectLayer();
                } else {
                    this.selected = true;
                    this.setCursor();
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                if (this.selected) this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, (msg, data)=>{
                if (this.selected) {
                    this.addMarker(data.latLngs);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $730e4c66c7c616fe$export$45fdd0118d421bcb.Id);
                }
            });
        };
        this.addMarker = (points)=>{
            const polyline = new $8e45d868956a51d9$exports.Polyline(points, {
                color: this._layerColour,
                weight: 10,
                opacity: 1,
                smoothFactor: 1
            }).on("edit", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $730e4c66c7c616fe$export$45fdd0118d421bcb.Id);
            });
            const popup = $8e45d868956a51d9$exports.popup({
                minWidth: 30,
                keepInView: true
            });
            const controlList = document.createElement("ul");
            controlList.classList.add("popup-buttons");
            const deleteControl = document.createElement("li");
            deleteControl.classList.add("delete-button");
            deleteControl.addEventListener("click", (e)=>{
                this.deleteMarker(polyline);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, popup);
            });
            controlList.appendChild(deleteControl);
            popup.setContent(controlList);
            polyline.on("click", (e)=>{
                this.markerOnClick(e);
                popup.setLatLng(e.latlng);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, popup);
            });
            this._layer.addLayer(polyline);
        };
        this.deleteMarker = (layer)=>{
            this._layer.removeLayer(layer);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $730e4c66c7c616fe$export$45fdd0118d421bcb.Id);
        };
        this.markerOnClick = (e)=>{
            this.selectLayer();
            const polyline = e.target;
            polyline.editing.enable();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $730e4c66c7c616fe$export$45fdd0118d421bcb.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this._layer.eachLayer((layer)=>{
                layer.editing.disable();
            });
            this.removeCursor();
            this.selected = false;
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $730e4c66c7c616fe$export$45fdd0118d421bcb.Id);
                return;
            }
            this.selected = true;
            const options = {
                color: this._layerColour,
                weight: 10,
                opacity: 1,
                smoothFactor: 1
            };
            const polyline = new $8e45d868956a51d9$exports.Draw.Polyline(map, options);
            polyline.enable();
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $730e4c66c7c616fe$export$45fdd0118d421bcb.Id);
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("car-free-street");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("car-free-street");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}






class $d068af3ea4113fe1$export$be3c1d75d6f7c214 {
    static #_ = (()=>{
        this.Id = "SchoolStreet";
    })();
    constructor(){
        this.id = $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id;
        this.title = "School Streets";
        this.groupName = "";
        this.selected = false;
        this.visible = false;
        this._prefix = "school-street";
        this._layerColour = "#E6EA09";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add school streets to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle Car-free streets from the map");
            const icon = document.createElement("i");
            icon.style.backgroundColor = this._layerColour;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            if (geoJson) {
                const schoolStreets = geoJson["features"];
                schoolStreets.forEach((schoolStreet)=>{
                    const points = new Array();
                    // For a brief period, saving nested the coordinates inside another array.
                    const coordinates = schoolStreet.geometry.coordinates.length === 1 ? schoolStreet.geometry.coordinates[0] : schoolStreet.geometry.coordinates;
                    coordinates.forEach((coordinate)=>{
                        const point = new $8e45d868956a51d9$exports.LatLng(coordinate[1], coordinate[0]);
                        points.push(point);
                    });
                    this.addMarker(points);
                });
            }
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, (msg, data)=>{
                if (this.selected) {
                    this.addMarker(data.latLngs);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id);
                }
            });
        };
        this.addMarker = (points)=>{
            const polyline = new $8e45d868956a51d9$exports.Polyline(points, {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            }).on("edit", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id);
            });
            const popup = $8e45d868956a51d9$exports.popup({
                minWidth: 30,
                keepInView: true
            });
            const controlList = document.createElement("ul");
            controlList.classList.add("popup-buttons");
            const deleteControl = document.createElement("li");
            deleteControl.classList.add("delete-button");
            deleteControl.addEventListener("click", (e)=>{
                this.deleteMarker(polyline);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, popup);
            });
            controlList.appendChild(deleteControl);
            popup.setContent(controlList);
            polyline.on("click", (e)=>{
                this.markerOnClick(e);
                popup.setLatLng(e.latlng);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, popup);
            });
            this._layer.addLayer(polyline);
        };
        this.deleteMarker = (layer)=>{
            this._layer.removeLayer(layer);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id);
        };
        this.markerOnClick = (e)=>{
            this.selectLayer();
            const polyline = e.target;
            polyline.editing.enable();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id);
        };
        this.onButtonClick = (event, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id);
                return;
            }
            this.selected = true;
            const options = {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            };
            const polyline = new $8e45d868956a51d9$exports.Draw.Polyline(map, options);
            polyline.enable();
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $d068af3ea4113fe1$export$be3c1d75d6f7c214.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this._layer.eachLayer((layer)=>{
                layer.editing.disable();
            });
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("school-street");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("school-street");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}






class $5aaf917ce866c119$export$d366dd6c0eae9085 {
    static #_ = (()=>{
        this.Id = "OneWayStreets";
    })();
    constructor(){
        this.id = $5aaf917ce866c119$export$d366dd6c0eae9085.Id;
        this.title = "One-way Streets";
        this.groupName = "";
        this.selected = false;
        this.visible = false;
        this._prefix = "one-way-street";
        this._layerColour = "#000000";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add one-way streets to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle Car-free streets from the map");
            const icon = document.createElement("i");
            icon.style.backgroundColor = this._layerColour;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            if (geoJson) {
                const oneWayStreets = geoJson["features"];
                oneWayStreets.forEach((oneWayStreet)=>{
                    const points = new Array();
                    // For a brief period, saving nested the coordinates inside another array, for some reason.
                    const coordinates = oneWayStreet.geometry.coordinates.length === 1 ? oneWayStreet.geometry.coordinates[0] : oneWayStreet.geometry.coordinates;
                    coordinates.forEach((coordinate)=>{
                        const point = new $8e45d868956a51d9$exports.LatLng(coordinate[1], coordinate[0]);
                        points.push(point);
                    });
                    this.addMarker(points);
                });
            }
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $5aaf917ce866c119$export$d366dd6c0eae9085.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, (msg, data)=>{
                if (this.selected) {
                    this.addMarker(data.latLngs);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $5aaf917ce866c119$export$d366dd6c0eae9085.Id);
                }
            });
        };
        this.addMarker = (points)=>{
            const polyline = new $8e45d868956a51d9$exports.Polyline(points, {
                color: this._layerColour,
                weight: 2,
                opacity: 1,
                smoothFactor: 1
            }).arrowheads({
                frequency: "50px",
                size: "15px",
                yawn: 40
            }).on("edit", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $5aaf917ce866c119$export$d366dd6c0eae9085.Id);
            });
            const popup = $8e45d868956a51d9$exports.popup({
                minWidth: 30,
                keepInView: true
            });
            const controlList = document.createElement("ul");
            controlList.classList.add("popup-buttons");
            const deleteControl = document.createElement("li");
            deleteControl.classList.add("delete-button");
            deleteControl.addEventListener("click", (e)=>{
                this.deleteMarker(polyline);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, popup);
            });
            controlList.appendChild(deleteControl);
            popup.setContent(controlList);
            polyline.on("click", (e)=>{
                this.markerOnClick(e);
                popup.setLatLng(e.latlng);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, popup);
            });
            this._layer.addLayer(polyline);
        };
        this.deleteMarker = (layer)=>{
            this._layer.removeLayer(layer);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $5aaf917ce866c119$export$d366dd6c0eae9085.Id);
        };
        this.markerOnClick = (e)=>{
            this.selectLayer();
            const polyline = e.target;
            polyline.editing.enable();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $5aaf917ce866c119$export$d366dd6c0eae9085.Id);
        };
        this.onButtonClick = (event, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $5aaf917ce866c119$export$d366dd6c0eae9085.Id);
                return;
            }
            this.selected = true;
            const options = {
                color: this._layerColour,
                weight: 5,
                opacity: 1,
                smoothFactor: 1
            };
            const polyline = new $8e45d868956a51d9$exports.Draw.Polyline(map, options);
            polyline.enable();
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $5aaf917ce866c119$export$d366dd6c0eae9085.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this._layer.eachLayer((layer)=>{
                layer.editing.disable();
            });
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("one-way-street");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("one-way-street");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}




class $fcc34177545e87cd$export$4c260019440d418f {
    static #_ = (()=>{
        this.createToolbarControl = (layers, settings, modalWindows, otherButtons)=>{
            const position = settings.readOnly ? "bottomleft" : "topleft";
            const toolbarControl = new $8e45d868956a51d9$exports.Control({
                position: position
            });
            toolbarControl.onAdd = (map)=>{
                return $fcc34177545e87cd$export$4c260019440d418f.generateToolbar(layers, settings, modalWindows, map, otherButtons);
            };
            return toolbarControl;
        };
    })();
    static #_1 = (()=>{
        this.generateToolbar = (layers, settings, modalWindows, map, otherButtons)=>{
            const buttons = $fcc34177545e87cd$export$4c260019440d418f.getButtons(layers, settings, modalWindows, otherButtons);
            const toolbarElement = document.createElement("ul");
            toolbarElement.classList.add("toolbar");
            const toolbarButtons = $fcc34177545e87cd$export$4c260019440d418f.generateToolbarButtons(buttons, map);
            toolbarElement.append(...toolbarButtons);
            return toolbarElement;
        };
    })();
    static #_2 = (()=>{
        this.getButtons = (layers, settings, modalWindows, otherButtons)=>{
            const buttons = new Array();
            if (!settings.readOnly) {
                layers.forEach((layer, layerName)=>{
                    if (settings.activeLayers.includes(layerName)) {
                        const button = layer.getToolbarButton();
                        buttons.push(button);
                    }
                });
                const groupButtonsToRemove = new Array();
                buttons.forEach((button)=>{
                    if (button.groupName) {
                        let parentButton = null;
                        const selectedGroupButtons = buttons.filter((b)=>b.groupName === button.groupName && b.selected);
                        if (selectedGroupButtons.length > 0) parentButton = selectedGroupButtons[0];
                        else {
                            const groupButtons = buttons.filter((b)=>b.groupName === button.groupName && b.isFirst);
                            if (groupButtons.length > 0) parentButton = groupButtons[0];
                        }
                        if (parentButton !== null) {
                            if (!parentButton.buttons) parentButton.buttons = new Array();
                            if (parentButton.id !== button.id) {
                                groupButtonsToRemove.push(button);
                                parentButton.buttons.push(button);
                            }
                        }
                    }
                });
                if (groupButtonsToRemove.length > 0) groupButtonsToRemove.forEach((button)=>{
                    const index = buttons.indexOf(button);
                    buttons.splice(index, 1);
                });
            }
            modalWindows.forEach((modalWindow)=>{
                buttons.push(modalWindow.getToolbarButton());
            });
            buttons.push(...otherButtons);
            return buttons;
        };
    })();
    static #_3 = (()=>{
        this.generateToolbarButtons = (buttons, map)=>{
            const toolbarButtons = new Array();
            buttons.forEach((button)=>{
                const buttonContainer = document.createElement("li");
                const buttonElement = $fcc34177545e87cd$export$4c260019440d418f.createButtonElement(button, map);
                buttonContainer.appendChild(buttonElement);
                if (button.buttons && button.buttons.length > 0) {
                    buttonContainer.classList.add("group");
                    const subToolbar = document.createElement("ul");
                    subToolbar.classList.add("hidden", "subToolbar");
                    button.buttons.forEach((b)=>{
                        const container = document.createElement("li");
                        container.appendChild($fcc34177545e87cd$export$4c260019440d418f.createButtonElement(b, map));
                        subToolbar.appendChild(container);
                    });
                    buttonElement.addEventListener("contextmenu", (event)=>{
                        $8e45d868956a51d9$exports.DomEvent.preventDefault(event);
                        subToolbar.classList.remove("hidden");
                    });
                    $fcc34177545e87cd$export$4c260019440d418f.onLongPress(buttonElement, (event)=>{
                        $8e45d868956a51d9$exports.DomEvent.preventDefault(event);
                        subToolbar.classList.remove("hidden");
                    });
                    buttonContainer.appendChild(subToolbar);
                    const indicator = document.createElement("span");
                    buttonContainer.appendChild(indicator);
                }
                toolbarButtons.push(buttonContainer);
            });
            return toolbarButtons;
        };
    })();
    static #_4 = (()=>{
        this.createButtonElement = (button, map)=>{
            const buttonElement = document.createElement("input");
            buttonElement.setAttribute("id", `${button.id}-button`);
            buttonElement.setAttribute("type", "button");
            buttonElement.classList.add("toolbar-button", `${button.id}`);
            buttonElement.setAttribute("title", button.tooltip);
            if (button.text) buttonElement.setAttribute("value", button.text);
            if (button.selected) buttonElement.classList.add("selected");
            buttonElement.addEventListener("click", (event)=>{
                $8e45d868956a51d9$exports.DomEvent.disableClickPropagation(buttonElement);
                button.action(event, map);
            });
            return buttonElement;
        };
    })();
    static #_5 = (()=>{
        this.onLongPress = (element, callback)=>{
            let timer;
            element.addEventListener("touchstart", ()=>{
                timer = setTimeout(()=>{
                    timer = undefined;
                    callback();
                }, 500);
            });
            function cancel() {
                clearTimeout(timer);
            }
            element.addEventListener("touchend", cancel);
            element.addEventListener("touchmove", cancel);
        };
    })();
}



class $5faf18e706b03854$export$ed247974535929c7 {
    static #_ = (()=>{
        this.create = (layers, activeLayers)=>{
            const legend = new $8e45d868956a51d9$exports.Control({
                position: "topright"
            });
            const div = document.createElement("div");
            div.classList.add("legend");
            const header = document.createElement("h4");
            header.textContent = "Legend";
            div.appendChild(header);
            const ul = document.createElement("ul");
            layers.forEach((layer, layerName)=>{
                if (activeLayers.includes(layerName)) ul.appendChild(layer.getLegendEntry());
            });
            div.appendChild(ul);
            const instructions = document.createElement("div");
            instructions.textContent = "Click item to toggle visibility";
            div.appendChild(instructions);
            legend.onAdd = (map)=>{
                return div;
            };
            return legend;
        };
    })();
}


class $6d5b99161b8439de$export$c72f6eaae7b9adff {
    constructor(){
        this.title = "Hello, Cleveland";
        this.readOnly = false;
        this.hideToolbar = false;
        this.activeLayers = new Array();
    }
}






class $79d2f2af9b629801$export$b45b3286e501897f {
    static #_ = (()=>{
        this.Id = "Settings";
    })();
    static #_1 = (()=>{
        this._prefix = "settings";
    })();
    static #_2 = (()=>{
        this.rowMargin = "mb-2";
    })();
    static #_3 = (()=>{
        this.inputDivClasses = [
            "form-check",
            "form-switch"
        ];
    })();
    static #_4 = (()=>{
        this.labelClasses = [
            "form-check-label",
            "inline-block",
            "text-gray-800"
        ];
    })();
    constructor(){
        this.id = $79d2f2af9b629801$export$b45b3286e501897f.Id;
        this.selected = false;
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = $79d2f2af9b629801$export$b45b3286e501897f._prefix;
            button.tooltip = "Change map settings";
            button.groupName = "";
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getControl = ()=>{
            return this._settingsBox;
        };
        this.update = (settings, layers)=>{
            this._settings = settings;
            this._layers = layers;
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, null);
                this.selected = false;
                return;
            }
            this.selected = true;
            PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showSettings, this);
        };
        this.create = (settings, layers)=>{
            const div = document.createElement("div");
            div.classList.add("modal");
            const header = document.createElement("h4");
            header.textContent = "Settings";
            div.appendChild(header);
            div.appendChild($79d2f2af9b629801$export$b45b3286e501897f.createTitle(settings.title, settings.readOnly));
            div.appendChild($79d2f2af9b629801$export$b45b3286e501897f.createZoom(settings.zoom));
            div.appendChild($79d2f2af9b629801$export$b45b3286e501897f.createCentre(settings.centre));
            div.appendChild($79d2f2af9b629801$export$b45b3286e501897f.createReadOnly(settings.readOnly));
            const layerSettings = $79d2f2af9b629801$export$b45b3286e501897f.createLayers(layers, settings);
            div.appendChild(layerSettings);
            const buttons = this.createButtons();
            div.appendChild(buttons);
            return div;
        };
        this.createButtons = ()=>{
            const element = document.createElement("div");
            element.classList.add("flex", "justify-center");
            element.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const saveButton = document.createElement("button");
            saveButton.type = "button";
            saveButton.textContent = "Save";
            saveButton.addEventListener("click", (event)=>{
                const settings = new (0, $6d5b99161b8439de$export$c72f6eaae7b9adff)();
                settings.title = document.getElementById("title")?.value;
                settings.readOnly = document.getElementById("read-only")?.checked;
                settings.zoom = this._settings.zoom;
                settings.centre = this._settings.centre;
                settings.version = this._settings.version;
                const layers = document.getElementsByName("layer");
                const array = Array.from(layers);
                const selectedLayers = new Array();
                array.forEach((layerElement)=>{
                    if (layerElement.checked) {
                        const layerId = layerElement.id;
                        selectedLayers.push(layerId);
                    }
                });
                settings.activeLayers = selectedLayers;
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).saveSettings, settings);
            });
            element.appendChild(saveButton);
            const cancelButton = document.createElement("button");
            cancelButton.type = "button";
            cancelButton.textContent = "Cancel";
            cancelButton.addEventListener("click", (event)=>{
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, null);
            });
            element.appendChild(cancelButton);
            return element;
        };
        this._settingsBox = new $8e45d868956a51d9$exports.Control({
            position: "bottomleft"
        });
        this._settingsBox.onAdd = (map)=>{
            return this.create(this._settings, this._layers);
        };
    }
    static #_5 = (()=>{
        this.createTitle = (title, isReadOnly)=>{
            const element = document.createElement("div");
            element.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const label = document.createElement("label");
            label.textContent = "Title";
            label.setAttribute("for", "title");
            element.appendChild(label);
            const input = document.createElement("input");
            input.id = "title";
            input.type = "text";
            input.value = title;
            input.classList.add("border-solid");
            input.readOnly = isReadOnly;
            element.appendChild(input);
            return element;
        };
    })();
    static #_6 = (()=>{
        this.createZoom = (zoom)=>{
            const element = document.createElement("div");
            element.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const label = document.createElement("label");
            label.textContent = "Zoom";
            label.setAttribute("for", "zoom");
            element.appendChild(label);
            const input = document.createElement("input");
            input.id = "zoom";
            input.type = "text";
            input.value = `${zoom}`;
            input.classList.add("border-solid");
            element.appendChild(input);
            return element;
        };
    })();
    static #_7 = (()=>{
        this.createCentre = (centre)=>{
            const element = document.createElement("div");
            element.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const label = document.createElement("label");
            label.textContent = "Centre";
            label.setAttribute("for", "centre");
            element.appendChild(label);
            const input = document.createElement("input");
            input.id = "centre";
            input.type = "text";
            input.value = `${centre.lat},${centre.lng}`;
            input.classList.add("border-solid");
            element.appendChild(input);
            return element;
        };
    })();
    static #_8 = (()=>{
        this.createReadOnly = (readOnly)=>{
            const div = document.createElement("div");
            div.classList.add("toggle", "flex", "justify-left");
            div.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const element = document.createElement("div");
            $79d2f2af9b629801$export$b45b3286e501897f.inputDivClasses.forEach((className)=>{
                element.classList.add(className);
            });
            const input = document.createElement("input");
            input.id = "read-only";
            input.type = "checkbox";
            input.checked = readOnly;
            input.setAttribute("role", "switch");
            element.appendChild(input);
            const label = document.createElement("label");
            label.textContent = "Read-only";
            label.setAttribute("for", "read-only");
            $79d2f2af9b629801$export$b45b3286e501897f.labelClasses.forEach((className)=>{
                label.classList.add(className);
            });
            element.appendChild(label);
            div.appendChild(element);
            return div;
        };
    })();
    static #_9 = (()=>{
        this.createLayers = (layers, settings)=>{
            const section = document.createElement("div");
            section.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const header = document.createElement("h4");
            header.textContent = "Visible Layers";
            section.appendChild(header);
            layers.forEach((layer)=>{
                const id = layer.id;
                const selected = settings.activeLayers.includes(id);
                section.appendChild($79d2f2af9b629801$export$b45b3286e501897f.createLayer(layer.title, id, selected, settings.readOnly));
            });
            return section;
        };
    })();
    static #_10 = (()=>{
        this.createLayer = (title, id, selected, disabled)=>{
            const div = document.createElement("div");
            div.classList.add("toggle", "flex", "justify-left");
            div.classList.add($79d2f2af9b629801$export$b45b3286e501897f.rowMargin);
            const element = document.createElement("div");
            $79d2f2af9b629801$export$b45b3286e501897f.inputDivClasses.forEach((className)=>{
                element.classList.add(className);
            });
            const label = document.createElement("label");
            label.textContent = title;
            label.setAttribute("for", id);
            element.appendChild(label);
            const input = document.createElement("input");
            input.id = id;
            input.name = "layer";
            input.type = "checkbox";
            input.role = "switch";
            input.checked = selected;
            input.disabled = disabled;
            element.appendChild(input);
            div.appendChild(element);
            return div;
        };
    })();
}





class $8b227324c9685988$export$60f9fa202430eb9a {
    static #_ = (()=>{
        this.Id = "Sharing";
    })();
    static #_1 = (()=>{
        this._prefix = "share";
    })();
    static #_2 = (()=>{
        this.rowMargin = "mb-2";
    })();
    static #_3 = (()=>{
        this.inputDivClasses = [
            "form-check",
            "form-switch"
        ];
    })();
    static #_4 = (()=>{
        this.checkboxClasses = [
            "form-check-input",
            "appearance-none",
            "w-9",
            "-ml-10",
            "rounded-full",
            "float-left",
            "h-5",
            "align-top",
            "bg-white",
            "bg-no-repeat",
            "bg-contain",
            "bg-gray-300",
            "focus:outline-none",
            "cursor-pointer",
            "shadow-sm"
        ];
    })();
    static #_5 = (()=>{
        this.labelClasses = [
            "form-check-label",
            "inline-block",
            "text-gray-800"
        ];
    })();
    static #_6 = (()=>{
        this.buttonClasses = [
            "inline-block",
            "px-6",
            "py-2.5",
            "bg-blue-600",
            "text-white",
            "font-medium",
            "text-xs",
            "leading-tight",
            "uppercase",
            "rounded",
            "shadow-md",
            "hover:bg-blue-700",
            "hover:shadow-lg",
            "hover:text-white",
            "focus:bg-blue-700",
            "focus:shadow-lg",
            "focus:outline-none",
            "focus:ring-0",
            "active:bg-blue-800",
            "active:shadow-lg",
            "transition",
            "duration-150",
            "ease-in-out"
        ];
    })();
    constructor(fileManager){
        this.id = $8b227324c9685988$export$60f9fa202430eb9a.Id;
        this.selected = false;
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = $8b227324c9685988$export$60f9fa202430eb9a._prefix;
            button.tooltip = "Share this map";
            button.groupName = "";
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getControl = ()=>{
            return this._sharingBox;
        };
        this.update = (settings, layers)=>{
            this._settings = settings;
            this._layers = layers;
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, null);
                this.selected = false;
                return;
            }
            this.selected = true;
            PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showSharingPopup, this);
        };
        this.create = ()=>{
            const form = document.createElement("form");
            form.id = "sharing";
            form.classList.add("popup", "modal");
            form.addEventListener("submit", (event)=>{
                event.preventDefault();
                const width = Number.parseInt(document.getElementById("width")?.value);
                const height = Number.parseInt(document.getElementById("height")?.value);
                const hideToolbar = document.getElementById("hide-toolbar")?.checked;
                this.CreateHtml(width, height, hideToolbar);
                const messageRow = document.getElementById("messageRow");
                if (messageRow !== null) messageRow.style.display = "block";
                return false;
            });
            const header = document.createElement("h4");
            header.textContent = "Share map";
            form.appendChild(header);
            form.appendChild($8b227324c9685988$export$60f9fa202430eb9a.createWidth());
            form.appendChild($8b227324c9685988$export$60f9fa202430eb9a.createHeight());
            form.appendChild($8b227324c9685988$export$60f9fa202430eb9a.createHideToolbar());
            form.appendChild($8b227324c9685988$export$60f9fa202430eb9a.createMessageRow());
            form.appendChild($8b227324c9685988$export$60f9fa202430eb9a.createButtons());
            return form;
        };
        this._fileManager = fileManager;
        this._sharingBox = new $8e45d868956a51d9$exports.Control({
            position: "bottomleft"
        });
        this._sharingBox.onAdd = (map)=>{
            return this.create();
        };
    }
    static #_7 = (()=>{
        this.createWidth = ()=>{
            const element = document.createElement("div");
            element.classList.add($8b227324c9685988$export$60f9fa202430eb9a.rowMargin);
            const widthLabel = document.createElement("label");
            widthLabel.textContent = "Width";
            widthLabel.setAttribute("for", "width");
            element.appendChild(widthLabel);
            const widthInput = document.createElement("input");
            widthInput.id = "width";
            widthInput.type = "number";
            widthInput.required = true;
            widthInput.classList.add("border-solid");
            element.appendChild(widthInput);
            let pxSpan = document.createElement("span");
            pxSpan.textContent = "px";
            element.appendChild(pxSpan);
            return element;
        };
    })();
    static #_8 = (()=>{
        this.createHeight = ()=>{
            const element = document.createElement("div");
            element.classList.add($8b227324c9685988$export$60f9fa202430eb9a.rowMargin);
            const heightLabel = document.createElement("label");
            heightLabel.textContent = "Height";
            heightLabel.setAttribute("for", "height");
            element.appendChild(heightLabel);
            const heightInput = document.createElement("input");
            heightInput.id = "height";
            heightInput.type = "number";
            heightInput.required = true;
            heightInput.classList.add("border-solid");
            element.appendChild(heightInput);
            const pxSpan = document.createElement("span");
            pxSpan.textContent = "px";
            element.appendChild(pxSpan);
            return element;
        };
    })();
    static #_9 = (()=>{
        this.createHideToolbar = ()=>{
            const div = document.createElement("div");
            div.classList.add("toggle");
            div.classList.add("flex");
            div.classList.add("justify-left");
            div.classList.add($8b227324c9685988$export$60f9fa202430eb9a.rowMargin);
            const element = document.createElement("div");
            $8b227324c9685988$export$60f9fa202430eb9a.inputDivClasses.forEach((className)=>{
                element.classList.add(className);
            });
            const input = document.createElement("input");
            input.id = "hide-toolbar";
            $8b227324c9685988$export$60f9fa202430eb9a.checkboxClasses.forEach((className)=>{
                input.classList.add(className);
            });
            input.type = "checkbox";
            input.setAttribute("role", "switch");
            element.appendChild(input);
            const label = document.createElement("label");
            label.textContent = "Hide toolbar";
            label.setAttribute("for", "hide-toolbar");
            $8b227324c9685988$export$60f9fa202430eb9a.labelClasses.forEach((className)=>{
                label.classList.add(className);
            });
            element.appendChild(label);
            div.appendChild(element);
            return div;
        };
    })();
    static #_10 = (()=>{
        this.createButtons = ()=>{
            const element = document.createElement("div");
            element.classList.add("flex");
            element.classList.add("justify-center");
            element.classList.add($8b227324c9685988$export$60f9fa202430eb9a.rowMargin);
            const saveButton = document.createElement("button");
            saveButton.type = "submit";
            saveButton.textContent = "Create";
            $8b227324c9685988$export$60f9fa202430eb9a.buttonClasses.forEach((className)=>{
                saveButton.classList.add(className);
            });
            element.appendChild(saveButton);
            const cancelButton = document.createElement("button");
            cancelButton.type = "button";
            cancelButton.textContent = "Close";
            $8b227324c9685988$export$60f9fa202430eb9a.buttonClasses.forEach((className)=>{
                cancelButton.classList.add(className);
            });
            cancelButton.addEventListener("click", (event)=>{
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, null);
            });
            element.appendChild(cancelButton);
            return element;
        };
    })();
    static createMessageRow() {
        const div = document.createElement("div");
        div.id = "messageRow";
        div.textContent = "Copied to clipboard";
        div.style.display = "none";
        return div;
    }
    CreateHtml(width, height, hideToolbar) {
        const mapHash = this._fileManager.saveMapToHash(this._settings, this._layers);
        const origin = window.location.origin;
        const html = `<iframe src="${origin}?hide-toolbar=${hideToolbar}#${mapHash}" width="${width}" height="${height}" title="title"></iframe>`;
        if (!navigator.clipboard) // Clipboard API not available
        return;
        navigator.clipboard.writeText(html).then(()=>{
            console.log("Text copied to clipboard...");
        }).catch((err)=>{
            console.log("Something went wrong", err);
        });
    }
}






class $2c7c622484205157$export$c71e73896d252398 {
    static #_ = (()=>{
        this.Id = "LtnCells";
    })();
    constructor(){
        this.id = $2c7c622484205157$export$c71e73896d252398.Id;
        this.title = "LTN Cells";
        this.groupName = "";
        this.selected = false;
        this.visible = false;
        this._prefix = "ltn";
        this._layerColour = "#cc00cc";
        this._ltnTitle = "1";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add LTNs to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.text = "LTN";
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle LTNs from the map");
            const icon = document.createElement("i");
            icon.style.backgroundColor = this._layerColour;
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            if (geoJson) {
                const ltnCells = geoJson["features"];
                ltnCells.forEach((ltnCell)=>{
                    const points = new Array();
                    const coordinates = ltnCell.geometry.coordinates;
                    const polygonCoordinates = coordinates[0];
                    polygonCoordinates.forEach((coordinate)=>{
                        points.push(new $8e45d868956a51d9$exports.LatLng(coordinate[1], coordinate[0]));
                    });
                    const properties = ltnCell.properties;
                    this.addLtnCell(points, properties.label, properties.color);
                });
            }
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            let json = {
                type: "FeatureCollection",
                features: new Array()
            };
            this._layer.eachLayer((layer)=>{
                let layerJson = layer.toGeoJSON();
                const properties = layer["properties"];
                layerJson.properties.label = properties.label;
                layerJson.properties.color = layer["options"].color;
                json.features.push(layerJson);
            });
            return json;
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $2c7c622484205157$export$c71e73896d252398.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                if (this.selected) this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, (msg, data)=>{
                if (this.selected) {
                    this.addLtnCell(data.latLngs, this._ltnTitle, this._layerColour);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $2c7c622484205157$export$c71e73896d252398.Id);
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapZoomChanged, (msg, zoomLevel)=>{
                this._layer.eachLayer((layer)=>{
                    if (zoomLevel < 14) layer.closeTooltip();
                    else layer.openTooltip();
                });
            });
        };
        this.addLtnCell = (points, label, color)=>{
            const polygon = new $8e45d868956a51d9$exports.Polygon(points, {
                color: color || this._layerColour,
                fillOpacity: 0.2,
                weight: 5,
                pane: "ltns"
            }).on("edit", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $2c7c622484205157$export$c71e73896d252398.Id);
            });
            polygon["properties"] = {};
            polygon["properties"].label = label;
            const tooltip = polygon.bindTooltip(label, {
                permanent: true,
                direction: "center"
            }).openTooltip();
            const popup = this.createPopup(polygon, tooltip, label);
            polygon.on("click", (e)=>{
                this.onPolygonClick(e);
                popup.setLatLng(e.target.getBounds().getCenter());
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, popup);
            });
            this._layer.addLayer(polygon);
        };
        this.createPopup = (polygon, tooltip, label)=>{
            const popup = $8e45d868956a51d9$exports.popup({
                minWidth: 30,
                keepInView: true
            });
            const controlList = document.createElement("ul");
            controlList.classList.add("popup-buttons");
            const labelControl = document.createElement("li");
            const labelElement = document.createElement("input");
            labelElement.type = "text";
            labelElement.value = label;
            labelElement.classList.add("label-editor");
            labelElement.addEventListener("keyup", (e)=>{
                const text = labelElement.value;
                tooltip.setTooltipContent(text);
                polygon["properties"].label = text;
                if (text.length == 0) polygon.closeTooltip();
                else polygon.openTooltip();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $2c7c622484205157$export$c71e73896d252398.Id);
            });
            labelControl.appendChild(labelElement);
            controlList.appendChild(labelControl);
            const deleteControl = document.createElement("li");
            deleteControl.classList.add("delete-button");
            deleteControl.addEventListener("click", (e)=>{
                this.delete(polygon);
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, popup);
            });
            controlList.appendChild(deleteControl);
            popup.setContent(controlList);
            return popup;
        };
        this.delete = (layer)=>{
            this._layer.removeLayer(layer);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $2c7c622484205157$export$c71e73896d252398.Id);
        };
        this.onPolygonClick = (e)=>{
            this.selectLayer();
            const polygon = e.target;
            polygon.editing.enable();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $2c7c622484205157$export$c71e73896d252398.Id);
        };
        this.onButtonClick = (event, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $2c7c622484205157$export$c71e73896d252398.Id);
                return;
            }
            this.selected = true;
            const options = {
                color: this._layerColour
            };
            const polygon = new $8e45d868956a51d9$exports.Draw.Polygon(map, options);
            polygon.enable();
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $2c7c622484205157$export$c71e73896d252398.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this._layer.eachLayer((layer)=>{
                layer.editing.disable();
            });
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("ltn-cell");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("ltn-cell");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON(undefined, {
            pane: "ltns"
        });
        this.setupSubscribers();
    }
}






class $cdf21d286031e65d$export$6ae4b277a36eba0d {
    static #_ = (()=>{
        this.Id = "BusGates";
    })();
    constructor(){
        this.id = $cdf21d286031e65d$export$6ae4b277a36eba0d.Id;
        this.title = "Bus Gates";
        this.groupName = "filters";
        this.selected = false;
        this.visible = false;
        this._prefix = "bus-gate";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._prefix;
            button.tooltip = "Add bus gates to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle bus gates from the map");
            const icon = document.createElement("i");
            icon.classList.add("bus-gate-icon");
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            geoJson["features"].forEach((busGate)=>{
                const coordinates = busGate.geometry.coordinates;
                const latLng = new $8e45d868956a51d9$exports.LatLng(coordinates[1], coordinates[0]);
                this.addMarker(latLng);
            });
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $cdf21d286031e65d$export$6ae4b277a36eba0d.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapClicked, (msg, e)=>{
                if (this.selected) {
                    $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
                    const latLng = e.latlng;
                    this.addMarker(latLng);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $cdf21d286031e65d$export$6ae4b277a36eba0d.Id);
                }
            });
        };
        this.addMarker = (latlng)=>{
            const busGate = new $8e45d868956a51d9$exports.Marker(latlng, {
                icon: new $8e45d868956a51d9$exports.DivIcon({
                    className: "bus-gate-icon"
                }),
                draggable: true,
                pane: "filters"
            }).on("click", (e)=>{
                this.deleteMarker(e);
            });
            this._layer.addLayer(busGate);
        };
        this.deleteMarker = (e)=>{
            $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
            const marker = e.target;
            this._layer.removeLayer(marker);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $cdf21d286031e65d$export$6ae4b277a36eba0d.Id);
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $cdf21d286031e65d$export$6ae4b277a36eba0d.Id);
                return;
            }
            this.selected = true;
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $cdf21d286031e65d$export$6ae4b277a36eba0d.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add("bus-gate");
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove("bus-gate");
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}





class $8c7d7a4037c18f41$export$78bddedbcf2939ac {
    static #_ = (()=>{
        this._prefix = "help";
    })();
    constructor(){
        this.selected = false;
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = $8c7d7a4037c18f41$export$78bddedbcf2939ac._prefix;
            button.tooltip = "Instructions on how to use the map";
            button.groupName = "";
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                this.selected = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideHelp, null);
                return;
            }
            this.selected = true;
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showHelp, this);
        };
    }
}






class $65a9a2795af735e1$export$91c29bb19cc0531c {
    static #_ = (()=>{
        this.Id = "MapManager";
    })();
    static #_1 = (()=>{
        this._prefix = "map-manager";
    })();
    static #_2 = (()=>{
        this.rowMargin = "mb-2";
    })();
    constructor(fileManager){
        this.id = $65a9a2795af735e1$export$91c29bb19cc0531c.Id;
        this.selected = false;
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = $65a9a2795af735e1$export$91c29bb19cc0531c._prefix;
            button.tooltip = "Save, load, and export maps";
            button.groupName = "";
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getControl = ()=>{
            return this._mapManagerBox;
        };
        this.update = (settings, layers)=>{
            this._layers = layers;
            this._settings = settings;
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, null);
                this.selected = false;
                return;
            }
            this.selected = true;
            PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showMapManager, this);
        };
        this.create = ()=>{
            const div = document.createElement("div");
            div.classList.add("modal");
            div.id = $65a9a2795af735e1$export$91c29bb19cc0531c._prefix;
            const header = document.createElement("h4");
            header.textContent = "Manage maps";
            div.appendChild(header);
            div.appendChild(this.createFileButtons());
            div.append(this.createNewMapSection());
            const layerSettings = this.createLocalStorageMapList();
            if (layerSettings !== null) div.appendChild(layerSettings);
            const buttons = $65a9a2795af735e1$export$91c29bb19cc0531c.createButtons();
            div.appendChild(buttons);
            return div;
        };
        this.createFileButtons = ()=>{
            const element = document.createElement("div");
            element.classList.add($65a9a2795af735e1$export$91c29bb19cc0531c.rowMargin);
            const newMapButton = document.createElement("input");
            newMapButton.type = "button";
            newMapButton.id = "new-map";
            newMapButton.classList.add("new-map");
            newMapButton.setAttribute("title", "Create a new map");
            newMapButton.addEventListener("click", (event)=>{
                event.stopPropagation();
                document.getElementById("create-new-map")?.classList.remove("hidden");
                document.getElementById("new-map-title")?.focus();
            });
            element.appendChild(newMapButton);
            const copyButton = document.createElement("input");
            copyButton.type = "button";
            copyButton.id = "copy-map";
            copyButton.classList.add("copy-map");
            copyButton.setAttribute("title", "Make a copy of this map");
            copyButton.addEventListener("click", (event)=>{
                event.stopPropagation();
                this._fileManager.copyMap(this._settings, this._layers);
                const mapListElement = document.getElementById("map-list");
                if (mapListElement) {
                    const newMapListElement = this.createLocalStorageMapList();
                    mapListElement.replaceWith(newMapListElement);
                }
            });
            element.appendChild(copyButton);
            const openFileButton = document.createElement("input");
            openFileButton.type = "button";
            openFileButton.id = "load-file";
            openFileButton.classList.add("load-file");
            openFileButton.setAttribute("title", "Load a map from a JSON file");
            openFileButton.addEventListener("click", (event)=>{
                event.stopPropagation();
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).loadMapFromFile);
            });
            element.appendChild(openFileButton);
            const saveFileButton = document.createElement("input");
            saveFileButton.type = "button";
            saveFileButton.id = "save-file";
            saveFileButton.classList.add("save-file");
            saveFileButton.setAttribute("title", "Save a map to a JSON file");
            saveFileButton.addEventListener("click", (event)=>{
                event.stopPropagation();
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).saveMapToFile);
            });
            element.appendChild(saveFileButton);
            const exportFileButton = document.createElement("input");
            exportFileButton.type = "button";
            exportFileButton.id = "save-geojson-file";
            exportFileButton.classList.add("save-geojson-file");
            exportFileButton.setAttribute("title", "Export a map to GeoJSON");
            exportFileButton.addEventListener("click", (event)=>{
                event.stopPropagation();
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).saveMapToGeoJSONFile);
            });
            element.appendChild(exportFileButton);
            return element;
        };
        this.createNewMapSection = ()=>{
            const section = document.createElement("div");
            section.id = "create-new-map";
            section.classList.add("hidden");
            const titleRow = document.createElement("div");
            titleRow.classList.add($65a9a2795af735e1$export$91c29bb19cc0531c.rowMargin);
            const label = document.createElement("label");
            label.textContent = "Title";
            label.setAttribute("for", "title");
            titleRow.appendChild(label);
            const input = document.createElement("input");
            input.id = "new-map-title";
            input.type = "text";
            input.value = "";
            input.classList.add("border-solid");
            titleRow.appendChild(input);
            section.appendChild(titleRow);
            const duplicateTitleRow = document.createElement("div");
            const message = document.createElement("span");
            message.id = "duplicate-title-error";
            message.classList.add("text-red-700", "hidden");
            duplicateTitleRow.appendChild(message);
            section.appendChild(duplicateTitleRow);
            const buttonRow = document.createElement("div");
            buttonRow.classList.add("flex");
            buttonRow.classList.add("justify-center");
            buttonRow.classList.add($65a9a2795af735e1$export$91c29bb19cc0531c.rowMargin);
            const createButton = document.createElement("button");
            createButton.type = "button";
            createButton.textContent = "Create";
            createButton.addEventListener("click", (event)=>{
                const settings = new (0, $6d5b99161b8439de$export$c72f6eaae7b9adff)();
                settings.zoom = this._settings.zoom;
                settings.centre = this._settings.centre;
                const title = document.getElementById("new-map-title")?.value;
                const existingMapTitle = this._fileManager.loadMapListFromStorage();
                if (existingMapTitle.includes(title)) {
                    message.textContent = `You already have a map named ${title}`;
                    message.classList.remove("hidden");
                    return;
                }
                message.classList.remove("hidden");
                settings.title = title;
                settings.readOnly = false;
                const layers = new Array();
                this._layers.forEach((layer, layerName)=>{
                    layers.push(layerName);
                });
                settings.activeLayers = layers;
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).createNewMap, settings);
            });
            buttonRow.appendChild(createButton);
            section.appendChild(buttonRow);
            return section;
        };
        this.createLocalStorageMapList = ()=>{
            const mapNames = this._fileManager.loadMapListFromStorage();
            if (mapNames.length > 0) {
                const section = document.createElement("div");
                section.id = "map-list";
                section.classList.add($65a9a2795af735e1$export$91c29bb19cc0531c.rowMargin);
                const header = document.createElement("h4");
                header.textContent = "Maps stored in your browser";
                section.appendChild(header);
                const instruction = document.createElement("div");
                instruction.classList.add("italic", "text-center", $65a9a2795af735e1$export$91c29bb19cc0531c.rowMargin);
                instruction.textContent = "Click map name to load that map";
                section.appendChild(instruction);
                const list = document.createElement("ul");
                mapNames.forEach((mapName)=>{
                    const isCurrentMap = mapName === this._settings.title;
                    list.appendChild(this.createMapListItem(mapName, isCurrentMap));
                });
                section.appendChild(list);
                return section;
            }
            return null;
        };
        this.createMapListItem = (mapName, isCurrentMap)=>{
            const listElement = document.createElement("li");
            listElement.classList.add("local-map");
            const label = document.createElement("span");
            if (isCurrentMap) {
                mapName = `${mapName} (current map)`;
                label.classList.add("font-bold");
            } else {
                label.classList.add("cursor-pointer");
                label.addEventListener("click", (event)=>{
                    event.stopPropagation();
                    const mapData = this._fileManager.loadMapFromStorage(mapName);
                    PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).fileLoaded, mapData);
                });
                const deleteButton = document.createElement("input");
                deleteButton.classList.add("delete-button", "float-right");
                deleteButton.type = "button";
                deleteButton.addEventListener("click", (event)=>{
                    event.stopPropagation();
                    this._fileManager.deleteMapFromStorage(mapName);
                    const mapListElement = document.getElementById("map-list");
                    if (mapListElement) {
                        const newMapListElement = this.createLocalStorageMapList();
                        mapListElement.replaceWith(newMapListElement);
                    }
                });
                listElement.appendChild(deleteButton);
            }
            label.textContent = mapName;
            listElement.appendChild(label);
            return listElement;
        };
        this._fileManager = fileManager;
        this._mapManagerBox = new $8e45d868956a51d9$exports.Control({
            position: "bottomleft"
        });
        this._mapManagerBox.onAdd = (map)=>{
            return this.create();
        };
    }
    static #_3 = (()=>{
        this.createButtons = ()=>{
            const element = document.createElement("div");
            element.classList.add("flex");
            element.classList.add("justify-center");
            element.classList.add($65a9a2795af735e1$export$91c29bb19cc0531c.rowMargin);
            const closeButton = document.createElement("button");
            closeButton.type = "button";
            closeButton.textContent = "Close";
            closeButton.addEventListener("click", (event)=>{
                PubSub.publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, null);
            });
            element.appendChild(closeButton);
            return element;
        };
    })();
}






class $aaebece58ac37587$export$718d4bbc30855d5b {
    static #_ = (()=>{
        this.Id = "TrafficLights";
    })();
    constructor(){
        this.id = $aaebece58ac37587$export$718d4bbc30855d5b.Id;
        this.title = "Traffic Lights";
        this.groupName = "traffic-controls";
        this.selected = false;
        this.visible = false;
        this._baseCssName = "traffic-lights";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._baseCssName;
            button.tooltip = "Add traffic lights to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            button.isFirst = true;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle traffic lights from the map");
            const icon = document.createElement("i");
            icon.classList.add(`${this._baseCssName}-icon`);
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            geoJson["features"].forEach((trafficLight)=>{
                const coordinates = trafficLight.geometry.coordinates;
                const latLng = new $8e45d868956a51d9$exports.LatLng(coordinates[1], coordinates[0]);
                this.addMarker(latLng);
            });
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $aaebece58ac37587$export$718d4bbc30855d5b.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapClicked, (msg, e)=>{
                if (this.selected) {
                    $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
                    const latLng = e.latlng;
                    this.addMarker(latLng);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $aaebece58ac37587$export$718d4bbc30855d5b.Id);
                }
            });
        };
        this.addMarker = (latlng)=>{
            const busGate = new $8e45d868956a51d9$exports.Marker(latlng, {
                icon: new $8e45d868956a51d9$exports.DivIcon({
                    className: `${this._baseCssName}-icon`
                }),
                draggable: true,
                pane: "filters"
            }).on("click", (e)=>{
                this.deleteMarker(e);
            });
            this._layer.addLayer(busGate);
        };
        this.deleteMarker = (e)=>{
            $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
            const marker = e.target;
            this._layer.removeLayer(marker);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $aaebece58ac37587$export$718d4bbc30855d5b.Id);
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $aaebece58ac37587$export$718d4bbc30855d5b.Id);
                return;
            }
            this.selected = true;
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $aaebece58ac37587$export$718d4bbc30855d5b.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add(this._baseCssName);
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove(this._baseCssName);
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}






class $1c298cec12d9117c$export$6ad8d275c7064aea {
    static #_ = (()=>{
        this.Id = "PedestrianLights";
    })();
    constructor(){
        this.id = $1c298cec12d9117c$export$6ad8d275c7064aea.Id;
        this.title = "Pedestrian Lights";
        this.groupName = "traffic-controls";
        this.selected = false;
        this.visible = false;
        this._baseCssName = "pedestrian-lights";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._baseCssName;
            button.tooltip = "Add pedestrian lights to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle pedestrian lights from the map");
            const icon = document.createElement("i");
            icon.classList.add(`${this._baseCssName}-icon`);
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            geoJson["features"].forEach((pedestrianLight)=>{
                const coordinates = pedestrianLight.geometry.coordinates;
                const latLng = new $8e45d868956a51d9$exports.LatLng(coordinates[1], coordinates[0]);
                this.addMarker(latLng);
            });
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $1c298cec12d9117c$export$6ad8d275c7064aea.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapClicked, (msg, e)=>{
                if (this.selected) {
                    $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
                    const latLng = e.latlng;
                    this.addMarker(latLng);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $1c298cec12d9117c$export$6ad8d275c7064aea.Id);
                }
            });
        };
        this.addMarker = (latlng)=>{
            const busGate = new $8e45d868956a51d9$exports.Marker(latlng, {
                icon: new $8e45d868956a51d9$exports.DivIcon({
                    className: `${this._baseCssName}-icon`
                }),
                draggable: true,
                pane: "filters"
            }).on("click", (e)=>{
                this.deleteMarker(e);
            });
            this._layer.addLayer(busGate);
        };
        this.deleteMarker = (e)=>{
            $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
            const marker = e.target;
            this._layer.removeLayer(marker);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $1c298cec12d9117c$export$6ad8d275c7064aea.Id);
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $1c298cec12d9117c$export$6ad8d275c7064aea.Id);
                return;
            }
            this.selected = true;
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $1c298cec12d9117c$export$6ad8d275c7064aea.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add(this._baseCssName);
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove(this._baseCssName);
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}






class $d568de4049d7f545$export$e8da368421c43c80 {
    static #_ = (()=>{
        this.Id = "ZebraCrossing";
    })();
    constructor(){
        this.id = $d568de4049d7f545$export$e8da368421c43c80.Id;
        this.title = "Zebra Crossing";
        this.groupName = "traffic-controls";
        this.selected = false;
        this.visible = false;
        this._baseCssName = "zebra-crossing";
        this.getToolbarButton = ()=>{
            const button = new (0, $aa9b293caf6adcb6$export$e5c1a33878e86e9e)();
            button.id = this._baseCssName;
            button.tooltip = "Add zebra crossings to the map";
            button.groupName = this.groupName;
            button.action = this.onButtonClick;
            button.selected = this.selected;
            return button;
        };
        this.getLegendEntry = ()=>{
            const holdingElement = document.createElement("li");
            holdingElement.id = `${this.id}-legend`;
            holdingElement.setAttribute("title", "Toggle zebra crossings from the map");
            const icon = document.createElement("i");
            icon.classList.add(`${this._baseCssName}-icon`);
            holdingElement.appendChild(icon);
            const text = document.createElement("span");
            text.textContent = this.title;
            holdingElement.appendChild(text);
            holdingElement.addEventListener("click", (e)=>{
                if (this.visible) {
                    this.visible = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, this.id);
                } else {
                    this.visible = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, this.id);
                }
            });
            return holdingElement;
        };
        this.loadFromGeoJSON = (geoJson)=>{
            geoJson["features"].forEach((zebraCrossing)=>{
                const coordinates = zebraCrossing.geometry.coordinates;
                const latLng = new $8e45d868956a51d9$exports.LatLng(coordinates[1], coordinates[0]);
                this.addMarker(latLng);
            });
        };
        this.getLayer = ()=>{
            return this._layer;
        };
        this.toGeoJSON = ()=>{
            return this._layer.toGeoJSON();
        };
        this.clearLayer = ()=>{
            this._layer.clearLayers();
            this.visible = false;
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg, selectedLayerId)=>{
                if (selectedLayerId !== $d568de4049d7f545$export$e8da368421c43c80.Id) this.deselectLayer();
                else this.selectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.deselectLayer();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapClicked, (msg, e)=>{
                if (this.selected) {
                    $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
                    const latLng = e.latlng;
                    this.addMarker(latLng);
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $d568de4049d7f545$export$e8da368421c43c80.Id);
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapZoomChanged, (msg, zoomLevel)=>{
                this._layer.eachLayer((layer)=>{
                    if (zoomLevel < 14) layer.closeTooltip();
                    else layer.openTooltip();
                });
            });
        };
        this.addMarker = (latlng)=>{
            const busGate = new $8e45d868956a51d9$exports.Marker(latlng, {
                icon: new $8e45d868956a51d9$exports.DivIcon({
                    className: `${this._baseCssName}-icon`
                }),
                draggable: true,
                pane: "filters"
            }).on("click", (e)=>{
                this.deleteMarker(e);
            });
            this._layer.addLayer(busGate);
        };
        this.deleteMarker = (e)=>{
            $8e45d868956a51d9$exports.DomEvent.stopPropagation(e);
            const marker = e.target;
            this._layer.removeLayer(marker);
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, $d568de4049d7f545$export$e8da368421c43c80.Id);
        };
        this.onButtonClick = (e, map)=>{
            if (this.selected) {
                this.deselectLayer();
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, $d568de4049d7f545$export$e8da368421c43c80.Id);
                return;
            }
            this.selected = true;
            this.setCursor();
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, $d568de4049d7f545$export$e8da368421c43c80.Id);
        };
        this.selectLayer = ()=>{
            this.selected = true;
            this.setCursor();
        };
        this.deselectLayer = ()=>{
            if (!this.selected) return;
            this.removeCursor();
            this.selected = false;
        };
        this.setCursor = ()=>{
            document.getElementById("map")?.classList.remove("leaflet-grab");
            document.getElementById("map")?.classList.add(this._baseCssName);
        };
        this.removeCursor = ()=>{
            document.getElementById("map")?.classList.remove(this._baseCssName);
            document.getElementById("map")?.classList.add("leaflet-grab");
        };
        this._layer = new $8e45d868956a51d9$exports.GeoJSON();
        this.setupSubscribers();
    }
}


class $be184c3e9c050c0e$export$23f3dfd47374502b {
    static #_ = (()=>{
        this._version = "0.8.1";
    })();
    constructor(fileManager){
        this._mapInitialised = false;
        this.setupPanes = (map)=>{
            const ltnsPane = map.createPane("ltns");
            ltnsPane.style.zIndex = "300";
            const filtersPane = map.createPane("filters");
            filtersPane.style.zIndex = "500";
        };
        this.setupLayers = ()=>{
            this._layers = new Map;
            this._layers.set((0, $98a6ce407b2c5f59$export$99f9902640797710).Id, new (0, $98a6ce407b2c5f59$export$99f9902640797710)());
            this._layers.set((0, $26c1c7c717c827e4$export$f023456fc9389cc6).Id, new (0, $26c1c7c717c827e4$export$f023456fc9389cc6)());
            this._layers.set((0, $45a16fc831ffc1cd$export$59b7e6c00f56503).Id, new (0, $45a16fc831ffc1cd$export$59b7e6c00f56503)());
            this._layers.set((0, $730e4c66c7c616fe$export$45fdd0118d421bcb).Id, new (0, $730e4c66c7c616fe$export$45fdd0118d421bcb)());
            this._layers.set((0, $d068af3ea4113fe1$export$be3c1d75d6f7c214).Id, new (0, $d068af3ea4113fe1$export$be3c1d75d6f7c214)());
            this._layers.set((0, $5aaf917ce866c119$export$d366dd6c0eae9085).Id, new (0, $5aaf917ce866c119$export$d366dd6c0eae9085)());
            this._layers.set((0, $2c7c622484205157$export$c71e73896d252398).Id, new (0, $2c7c622484205157$export$c71e73896d252398)());
            this._layers.set((0, $cdf21d286031e65d$export$6ae4b277a36eba0d).Id, new (0, $cdf21d286031e65d$export$6ae4b277a36eba0d)());
            this._layers.set((0, $aaebece58ac37587$export$718d4bbc30855d5b).Id, new (0, $aaebece58ac37587$export$718d4bbc30855d5b)());
            this._layers.set((0, $1c298cec12d9117c$export$6ad8d275c7064aea).Id, new (0, $1c298cec12d9117c$export$6ad8d275c7064aea)());
            this._layers.set((0, $d568de4049d7f545$export$e8da368421c43c80).Id, new (0, $d568de4049d7f545$export$e8da368421c43c80)());
            this.activateAllLayers();
        };
        this.setupModalWindowControls = ()=>{
            this._modalWindows = new Array();
            const mapManagerControl = new (0, $65a9a2795af735e1$export$91c29bb19cc0531c)(this._fileManager);
            this._modalWindows.push(mapManagerControl);
            const settingsControl = new (0, $79d2f2af9b629801$export$b45b3286e501897f)();
            this._modalWindows.push(settingsControl);
            const sharingControl = new (0, $8b227324c9685988$export$60f9fa202430eb9a)(this._fileManager);
            this._modalWindows.push(sharingControl);
        };
        this.addTileLayer = ()=>{
            const tileLayer = new $8e45d868956a51d9$exports.TileLayer("https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png", {
                attribution: '<a href="https://saferstreetmaker.org" target="_blank">saferstreetmaker.org</a> | &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
                maxZoom: 20
            });
            this._map.addLayer(tileLayer);
        };
        this.addToolbar = (layers, settings, modalWindows)=>{
            const otherButtons = new Array();
            otherButtons.push(this._helpButton.getToolbarButton());
            this._toolbarControl = (0, $fcc34177545e87cd$export$4c260019440d418f).createToolbarControl(layers, settings, modalWindows, otherButtons);
            this._map.addControl(this._toolbarControl);
        };
        this.addLegend = (layers, settings)=>{
            this._legend = (0, $5faf18e706b03854$export$ed247974535929c7).create(layers, settings.activeLayers);
            this._map.addControl(this._legend);
        };
        this.setupCloseHelpButtons = ()=>{
            document.getElementsByName("closeHelp").forEach((element)=>{
                element.addEventListener("click", (e)=>{
                    this.showPopup("help");
                });
            });
        };
        this.clearAllLayers = ()=>{
            this._layers.forEach((layer, layerName)=>{
                layer.clearLayer();
                this._map.removeLayer(layer.getLayer());
            });
        };
        this.removeAllLayers = ()=>{
            this._layers.forEach((layer, layerName)=>{
                this._map.removeLayer(layer.getLayer());
            });
        };
        this.activateAllLayers = ()=>{
            this._settings.activeLayers = [];
            this._layers.forEach((layer, layerName)=>{
                this._settings.activeLayers.push(layerName);
            });
        };
        this.resetSettings = ()=>{
            this._settings.readOnly = false;
            this.activateAllLayers();
        };
        this.updateUI = (settings)=>{
            this.refreshToolbar(settings);
            this.refreshLegend(settings);
        };
        this.refreshToolbar = (settings)=>{
            if (this._toolbarControl !== undefined) this._map.removeControl(this._toolbarControl);
            if (!settings.hideToolbar) this.addToolbar(this._layers, settings, this._modalWindows);
        };
        this.refreshLegend = (settings)=>{
            if (this._legend !== undefined) this._map.removeControl(this._legend);
            this.addLegend(this._layers, settings);
        };
        this.toggleModalWindowVisibility = (windowToShow)=>{
            this._modalWindows.forEach((modalWindow)=>{
                if (windowToShow === null || modalWindow.id !== windowToShow.id) {
                    modalWindow.selected = false;
                    this._map.removeControl(modalWindow.getControl());
                }
            });
            this.refreshToolbar(this._settings);
        };
        this.setupMapEventHandlers = ()=>{
            this._map.on("click", (e)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapClicked, e);
            });
            this._map.on("keyup", (e)=>{
                if (e.originalEvent.key === "Escape") {
                    this._map.closePopup();
                    (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected);
                }
            });
            this._map.on("draw:created", (e)=>{
                const layer = e.layer;
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).drawCreated, {
                    latLngs: layer.getLatLngs(),
                    map: this._map
                });
            });
            this._map.on("zoomend", (e)=>{
                const zoom = this._map.getZoom();
                const mapElement = document.getElementById("map");
                if (mapElement) {
                    for(let i = mapElement.classList.length - 1; i >= 0; i--){
                        const className = mapElement.classList[i];
                        if (className.startsWith("zoom")) mapElement.classList.remove(className);
                    }
                    mapElement.classList.add(`zoom-${zoom}`);
                }
                (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).publish((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).mapZoomChanged, zoom);
                this._settings.zoom = zoom;
                this._settings.centre = this._map.getCenter();
                this.saveMap();
            });
            this._map.on("moveend", (e)=>{
                this._settings.zoom = this._map.getZoom();
                this._settings.centre = this._map.getCenter();
                this.saveMap();
            });
        };
        this.setupSubscribers = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).fileLoaded, (msg, data)=>{
                this.toggleModalWindowVisibility(null);
                this.clearAllLayers();
                this.resetSettings();
                let mapLoaded = false;
                const errors = new Array();
                try {
                    mapLoaded = this.loadMapData(data, null, null);
                } catch (e) {
                    errors.push("There was a problem loading the map from uploaded file:");
                    errors.push(e.message);
                    errors.push(e.stack);
                    this.showErrors(errors);
                }
                if (mapLoaded) {
                    this.saveMap();
                    this.updateUI(this._settings);
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerUpdated, (msg)=>{
                this.saveMap();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showPopup, (msg, popup)=>{
                this._map.openPopup(popup);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).closePopup, (msg, popup)=>{
                this._map.closePopup(popup);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).saveMapToFile, (msg)=>{
                const centre = this._map.getCenter();
                const zoom = this._map.getZoom();
                this._fileManager.saveMapToFile(this._settings, this._layers);
                this.toggleModalWindowVisibility(null);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).saveMapToGeoJSONFile, (msg)=>{
                this._fileManager.saveMapToGeoJSONFile(this._settings, this._layers);
                this.toggleModalWindowVisibility(null);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).loadMapFromFile, (msg)=>{
                try {
                    this._fileManager.loadMapFromFile();
                } catch (e) {
                    const errors = new Array();
                    errors.push("There was a problem loading the map from uploaded file:");
                    errors.push(e.message);
                    errors.push(e.stack);
                    this.showErrors(errors);
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideModalWindows, (msg, windowToShow)=>{
                this.toggleModalWindowVisibility(windowToShow);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showSettings, (msg, settingsControl)=>{
                this.toggleModalWindowVisibility(settingsControl);
                settingsControl.update(this._settings, this._layers);
                this._map.addControl(settingsControl.getControl());
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).saveSettings, (msg, settings)=>{
                this._settings = settings;
                this.updateUI(settings);
                this.removeAllLayers();
                this.addLayers(settings);
                this.saveMap();
                this.toggleModalWindowVisibility(null);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showMapManager, (msg, mapManagerControl)=>{
                this.toggleModalWindowVisibility(mapManagerControl);
                mapManagerControl.update(this._settings, this._layers);
                this._map.addControl(mapManagerControl.getControl());
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).createNewMap, (msg, settings)=>{
                this._settings = settings;
                this.updateUI(settings);
                this.clearAllLayers();
                this.removeAllLayers();
                this.addLayers(settings);
                this.saveMap();
                this.toggleModalWindowVisibility(null);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showSharingPopup, (msg, sharingControl)=>{
                this.toggleModalWindowVisibility(sharingControl);
                sharingControl.update(this._settings, this._layers);
                this._map.addControl(sharingControl.getControl());
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showHelp, (msg)=>{
                this.refreshToolbar(this._settings);
                this.showPopup("help");
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideHelp, (msg)=>{
                this.refreshToolbar(this._settings);
                this.showPopup("help");
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).hideLayer, (msg, layerId)=>{
                var layer = this._layers.get(layerId);
                if (layer !== undefined) {
                    this._map.removeLayer(layer.getLayer());
                    document.getElementById(`${layerId}-legend`)?.classList.add("disabled");
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).showLayer, (msg, layerId)=>{
                var layer = this._layers.get(layerId);
                if (layer !== undefined) {
                    const layerToAdd = layer.getLayer();
                    this._map.addLayer(layerToAdd);
                    document.getElementById(`${layerId}-legend`)?.classList.remove("disabled");
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerDeselected, (msg)=>{
                this.refreshToolbar(this._settings);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($e1221edafe081d67$exports))).subscribe((0, $67a3d5749d1c0a9d$export$c2505dec65d17c74).layerSelected, (msg)=>{
                this.refreshToolbar(this._settings);
            });
        };
        this.setUserLocation = (userLocation)=>{
            const coordinates = userLocation.coords;
            this._map.setView([
                coordinates.latitude,
                coordinates.longitude
            ], 17);
        };
        this.setDefaultView = ()=>{
            this._map.setView([
                52.5,
                -1.9
            ], 12);
        };
        this.loadMap = async (remoteMapFile, hash, hideToolbar, zoom, centre)=>{
            if (this._mapInitialised) {
                this.removeAllLayers();
                this.resetSettings();
            } else {
                this.addLayers(this._settings);
                this.setupMapEventHandlers();
                this.setupSubscribers();
                this._mapInitialised = true;
            }
            let mapLoaded = false;
            let geoJSON = "";
            const errors = new Array();
            let errorIntro = "";
            let loadingFromStorage = false;
            try {
                if (remoteMapFile) {
                    errorIntro = "There was a problem loading the map from the remote file location:";
                    geoJSON = await this._fileManager.loadMapFromRemoteFile(remoteMapFile);
                } else if (hash !== "") {
                    errorIntro = "There was a problem loading the map from the hash:";
                    geoJSON = this._fileManager.loadMapFromHash(hash.slice(1));
                } else {
                    loadingFromStorage = true;
                    const lastMapSelected = this._fileManager.loadLastMapSelected();
                    errorIntro = "There was a problem loading the map from local storage:";
                    geoJSON = this._fileManager.loadMapFromStorage(lastMapSelected || this._settings.title);
                }
                errorIntro = "There was a problem processing the map file:";
                mapLoaded = this.loadMapData(geoJSON, zoom, centre);
            } catch (e) {
                errors.push(errorIntro);
                if (loadingFromStorage) errors.push('<a id="downloadErrorFile">Click to download the map from local storage</a>');
                errors.push(e.message);
                errors.push(e.stack);
                this.showErrors(errors);
                if (loadingFromStorage) {
                    const downloadLink = document.getElementById("downloadErrorFile");
                    downloadLink?.addEventListener("click", (e)=>{
                        this.downloadStorageMap();
                    });
                }
            }
            this._settings.hideToolbar = hideToolbar;
            this.updateUI(this._settings);
            return mapLoaded;
        };
        this.downloadStorageMap = ()=>{
            const lastMapSelected = this._fileManager.loadLastMapSelected();
            const mapJSON = this._fileManager.loadMapFromStorage(lastMapSelected);
            const mapString = JSON.stringify(mapJSON);
            const blob = new Blob([
                mapString
            ], {
                type: "text/plain;charset=utf-8"
            });
            const hyperlink = document.createElement("a");
            hyperlink.href = URL.createObjectURL(blob);
            hyperlink.download = `invalidMapData.json`;
            hyperlink.click();
        };
        this.loadMapData = (geoJSON, zoom, centre)=>{
            if (geoJSON === null) return false;
            if (geoJSON["title"] !== undefined) this._settings.title = geoJSON["title"];
            if (geoJSON["settings"] !== undefined) this._settings = geoJSON["settings"];
            if (geoJSON["layers"] !== undefined) {
                const layersJSON = geoJSON["layers"];
                this._layers.forEach((layer, layerName)=>{
                    if (layerName === (0, $98a6ce407b2c5f59$export$99f9902640797710).Id && layersJSON["Modals"] !== undefined) layerName = "Modals";
                    else if (layerName === (0, $26c1c7c717c827e4$export$f023456fc9389cc6).Id && layersJSON["CycleLanes"] !== undefined) layerName = "CycleLanes";
                    const layerJSON = layersJSON[layerName];
                    if (layerJSON) layer.loadFromGeoJSON(layerJSON);
                    if (this._settings.activeLayers.includes(layerName)) this._map.addLayer(layer.getLayer());
                    else this._map.removeLayer(layer.getLayer());
                });
            }
            if (this._settings && !this._settings.centre) {
                this._settings.centre = geoJSON["centre"];
                this._settings.zoom = geoJSON["zoom"];
            }
            if (this._settings) this._settings.version = $be184c3e9c050c0e$export$23f3dfd47374502b._version;
            if (zoom) this._settings.zoom = Number(zoom);
            if (centre && centre.length === 2) this._settings.centre = new $8e45d868956a51d9$exports.LatLng(centre[0], centre[1]);
            if (this._settings.centre) this._map.setView([
                this._settings.centre.lat,
                this._settings.centre.lng
            ], this._settings.zoom);
            else this.setDefaultView();
            return true;
        };
        this.saveMap = ()=>{
            this._fileManager.saveMap(this._settings, this._layers);
        };
        this.showErrors = (errorMessages)=>{
            const errorMessagesElement = document.getElementById("errorMessages");
            if (errorMessagesElement !== null) {
                errorMessagesElement.innerHTML = errorMessages.join("<br />");
                this.showPopup("errors");
            }
        };
        this.showPopup = (popupId)=>{
            const popupElement = document.getElementById(popupId);
            if (popupElement === null) return;
            if (popupElement.classList.contains("fadeOut")) {
                popupElement.classList.remove("fadeOut");
                popupElement?.classList.add("fadeIn");
            } else {
                popupElement?.classList.remove("fadeIn");
                popupElement.classList.add("fadeOut");
            }
        };
        this._fileManager = fileManager;
        this._settings = new (0, $6d5b99161b8439de$export$c72f6eaae7b9adff)();
        this._settings.title = "Hello Cleveland";
        this._map = new $8e45d868956a51d9$exports.Map("map");
        this.setupPanes(this._map);
        this.setupLayers();
        this._helpButton = new (0, $8c7d7a4037c18f41$export$78bddedbcf2939ac)();
        this.setupModalWindowControls();
        this.addTileLayer();
        this.setupCloseHelpButtons();
    }
    addLayers(settings) {
        this._layers.forEach((layer, layerName)=>{
            if (settings.activeLayers.includes(layerName)) {
                layer.visible = true;
                const layerToAdd = layer.getLayer();
                this._map.addLayer(layerToAdd);
            }
        });
    }
}


document.addEventListener("DOMContentLoaded", async ()=>{
    const fileManager = new (0, $b15097c11fd8381b$export$a5245c9b2355d1f8)();
    const mapContainer = new (0, $be184c3e9c050c0e$export$23f3dfd47374502b)(fileManager);
    const params = new URLSearchParams(window.location.search);
    const remoteMapFile = params.get("map");
    const hash = window.location.hash;
    const hideToolbar = params.get("hide-toolbar") === "true";
    const zoom = params.get("zoom");
    const centreString = params.get("centre");
    let centre = null;
    if (centreString) {
        const centreStrings = centreString.split(",");
        if (centreStrings !== null && centreStrings.length === 2) {
            const lat = Number(centreStrings[0]);
            const long = Number(centreStrings[1]);
            if (!isNaN(lat) && !isNaN(long)) {
                centre = new Array();
                centre.push(lat);
                centre.push(long);
            }
        }
    }
    const mapLoaded = await mapContainer.loadMap(remoteMapFile, hash, hideToolbar, zoom, centre);
    if (!mapLoaded && window.navigator.geolocation) window.navigator.geolocation.getCurrentPosition(mapContainer.setUserLocation, mapContainer.setDefaultView);
});


//# sourceMappingURL=index.cde33d18.js.map
